.root {
  left: 0;
  right: 0;
  bottom: 0;
}

.content {
  border-radius: 0;
}

.message {
  display: flex;
  align-items: center;
  text-align: left;
  text-transform: initial;
}

.icon {
  font-size: 20;
}

.iconVariant {
  opacity: 0.9;
  margin-right: 16px;
}
